import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSocketContext } from "./SocketContext";
import { toast } from "react-toastify";
import welcomeMessage from "./assets/audios/messageTone3.mp3";
import { setNewOrders } from "./slices/newOrdersSlice";

const useListenMessages = () => {
  const { socketDetails: socket } = useSocketContext();
  const { userInfo } = useSelector((state) => state.auth);
  const [isToggled, setIsToggled] = useState(userInfo?.audioOn);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!socket) return;
    const handleNewMessage = (orderDetails) => {
      // console.log(new Date().getMinutes() + " : " + new Date().getSeconds());
      // console.log("orderDetails");
      // console.log(orderDetails.itemCreated);
      // toast.success("new data available : ");
      if (orderDetails?.itemCreated?.orderType !== "outlet")
        toast.success(() => (
          <>
            <audio src={welcomeMessage} type="audio/mp3" autoPlay={true} /> New
            Order Placed
          </>
        ));

      dispatch(setNewOrders([orderDetails.itemCreated]));
    };

    // Attach listener
    socket.on("new_order_update", handleNewMessage);

    // Cleanup listener
    return () => {
      socket.off("new_order_update", handleNewMessage);
    };
  }, [socket]);
};
export default useListenMessages;
